import {
  SETUP_COLUMNS,
  ADD_GROUP_COLUMN,
  REMOVE_GROUP_COLUMN,
  TOGGLE_GROUP_COLUMN_SORT,
  CHANGE_SORT_COLUMN,
  TOGGLE_COLUMN_VISIBILITY,
  REORDER_COLUMN,
  UPDATE_FILTER,
  SHOW_DEFINED_VIEW,
  UPDATE_ACTIVE_PAGE,
  UPDATE_NUM_ITEMS_PER_PAGE,
  GET_PAGE_DATA_REQUEST,
  GET_PAGE_DATA_SUCCESS,
  GET_PAGE_DATA_FAILURE,
  GET_DETAIL_DATA_REQUEST,
  GET_DETAIL_DATA_SUCCESS,
  GET_DETAIL_DATA_FAILURE
} from "../Actions/DashboardActions";

import _ from "lodash";

const initial_state = {
  sortBy: null,
  sortOrder: null,
  activePage: 1,
  itemsPerPage: 15,
  filters: {},
  columns: [],
  totalPages: 0,
  totalRows: 0
};
export function dashboard(state = initial_state, action) {
  //define constants useful for certain switch cases first
  const col = action.col || {};

  switch (action.type) {
    case SETUP_COLUMNS:
      return Object.assign({}, state, {
        columns: action.columns
      });

    case ADD_GROUP_COLUMN:
      var new_group = {
        col_id: col.ID,
        sortOrder: "asc"
      };
      return Object.assign({}, state, {
        grouping: _.uniqBy(_.concat(state.grouping || [], new_group), "col_id")
      });
    case REMOVE_GROUP_COLUMN:
      return Object.assign({}, state, {
        grouping: _.filter(state.grouping || [], group => {
          return group.col_id !== action.col_id;
        })
      });
    case TOGGLE_GROUP_COLUMN_SORT:
      return Object.assign({}, state, {
        grouping: _.map(state.grouping || [], group => {
          if (group.col_id === action.col_id) {
            group = Object.assign({}, group, {
              sortOrder: group.sortOrder === "asc" ? "desc" : "asc"
            });
          }
          return group;
        })
      });

    case CHANGE_SORT_COLUMN:
      var new_sort_order = "ascending";
      var new_sort_field = action.field;
      if (state.sortBy === action.field) {
        if (state.sortOrder === "ascending") {
          new_sort_order = "descending";
        } else if (state.sortOrder === "descending") {
          new_sort_order = null;
          new_sort_field = null;
        }
      }
      return Object.assign({}, state, {
        sortBy: new_sort_field,
        sortOrder: new_sort_order
      });

    case TOGGLE_COLUMN_VISIBILITY:
      return Object.assign({}, state, {
        columns: _.map(state.columns, col => {
          if (col.ID === action.col_id) {
            col = Object.assign({}, col, {
              hidden: !col.hidden
            });
          }
          return col;
        })
      });

    case REORDER_COLUMN:
      var reorderedColumns = _.cloneDeep(state.columns);
      reorderedColumns.splice(
        action.new_idx,
        0,
        reorderedColumns.splice(action.cur_idx, 1)[0]
      );
      return Object.assign({}, state, {
        columns: reorderedColumns
      });

    case UPDATE_FILTER:
      return Object.assign({}, state, {
        activePage: 1,
        filters: Object.assign({}, state.filters, {
          [action.filter_field]: {
            value: action.value,
            type: action.filter_type
          }
        })
      });

    case SHOW_DEFINED_VIEW:
      return Object.assign({}, state, {
        grouping: action.view.grouping || [],
        sortBy: action.view.sortBy || null,
        sortOrder: action.view.sortOrder || null,
        activePage: action.view.activePage || 1,
        itemsPerPage: action.view.itemsPerPage || 15,
        filters: action.view.filters || {},
        columns: action.view.columns || []
      });

    case UPDATE_ACTIVE_PAGE:
      return Object.assign({}, state, {
        activePage: action.page
      });

    case UPDATE_NUM_ITEMS_PER_PAGE:
      return Object.assign({}, state, {
        activePage: 1,
        itemsPerPage: action.num_items
      });

    case GET_PAGE_DATA_REQUEST:
      return Object.assign({}, state, {
        fetchingPageData: true
      });
    case GET_PAGE_DATA_SUCCESS:
      return Object.assign({}, state, {
        fetchingPageData: false,
        pageData: action.data.pageData,
        totalPages: action.data.totalPages,
        totalRows: action.data.totalRows,
        errorFetchingPageData: false
      });
    case GET_PAGE_DATA_FAILURE:
      return Object.assign({}, state, {
        fetchingPageData: false,
        pageData: [],
        totalPages: 0,
        totalRows: 0,
        errorFetchingPageData: true
      });

    case GET_DETAIL_DATA_REQUEST:
      return Object.assign({}, state, {
        ["fetching_" + action.detail_type]: true,
        ["error_fetching_" + action.detail_type]: false,
        ["error_details_" + action.detail_type]: "",
        [action.detail_type]: null
      });
    case GET_DETAIL_DATA_SUCCESS:
      return Object.assign({}, state, {
        ["fetching_" + action.detail_type]: false,
        ["error_fetching_" + action.detail_type]: false,
        ["error_details_" + action.detail_type]: "",
        [action.detail_type]: action.data
      });
    case GET_DETAIL_DATA_FAILURE:
      return Object.assign({}, state, {
        ["fetching_" + action.detail_type]: false,
        ["error_fetching_" + action.detail_type]: true,
        ["error_details_" + action.detail_type]: action.error,
        [action.detail_type]: null
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/DashboardReducer.js